import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  justify-content: right;
`;
export const ContentWrapper = styled.div`
  max-width: 400px;
`;
